<template>
    <div>
        <limitless-page-header :title="'Användare'">
            <template #header-elements>
                <limitless-page-header-button v-if="hasPermission('red_edit_users_information')" :route="{ name: 'users.kitchen_schedule' }" icon="icon-gift">Köksveckor</limitless-page-header-button>
                <limitless-page-header-button v-if="hasPermission('red_edit_users_information')" :route="{ name: 'users.birthdays' }" icon="icon-gift">Födelsedagar</limitless-page-header-button>
                <limitless-page-header-button v-if="hasPermission('red_edit_users_timecare')" :route="{ name: 'users.absensestatistics' }" icon="icon-database-time2">Frånvarostatistik</limitless-page-header-button>
                <limitless-page-header-button v-if="hasPermission('red_edit_users_timecare')" :route="{ name: 'jobs.dispatch' }" icon="icon-cloud-upload">Registrera i FortNox</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <form @submit.prevent="getData">
                <div class="row mb-1">
                    <div class="col-xl-4">
                        <div class="input-group">
                            <input class="form-control" v-model="table_filter.search" placeholder="Sök...">
                            <span class="input-group-append">
                                <limitless-button @click="getData" :busy="busy_loading">Sök</limitless-button>
                            </span>
                        </div>
                    </div>
                    <div class="col-xl-8 text-right">
                        <router-link
                            :to="{ name: 'user.edit', params: { id: 0 } }"
                            class="btn btn-primary btn-labeled btn-labeled-left"
                        >
                            <b><i class="icon-plus3"></i></b>Ny användare
                        </router-link>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-xl-4">
                        <div class="form-check form-check-inline">
                            <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" v-model="table_filter.showhidden" :true-value="1" :false-value="0">
                                Visa alla
                            </label>
                        </div>
                    </div>
                </div>
            </form>

            <div class="mb-3">
                <a v-for="(store, s_idx) in stores" :href="'#store-' + store.store_id" :key="'s-' + s_idx" class="btn btn-light btn-sm mr-1">{{ store.name }}</a>
            </div>

            <div class="card">
                <table v-if="table_data && table_data.length > 0" class="table table-striped table-xs">
                    <tbody v-for="store in table_data" :key="'store-' + store.store_id">
                        <tr class="table-active" :id="'store-' + store.store_id">
                            <th
                                :colspan="hasPermission('red_edit_users_timecare') ? 9 : 8"
                                style="padding: 16px 8px; font-size: 1rem; border-top-style: solid; border-top-color: #00BCD4 !important; border-top-width: 2px;">
                                <i class="icon-office mr-2"></i>{{ store.name }}
                            </th>
                        </tr>
                        <tr>
                            <th>Användarnamn</th>
                            <th>Namn</th>
                            <th>Titel/Anvsvar</th>
                            <th class="text-center">TIMECARE</th>
                            <th class="text-center">INTRA</th>
                            <th class="text-center">REMOTE</th>
                            <th>E-post (arbete)</th>
                            <th>Telefon (arbete)</th>
                            <th class="text-right" v-if="hasPermission('red_edit_users_timecare')">Varningar</th>
                        </tr>
                        <tr v-for="user in store.users" :key="'user-' + user.UserID"  :style="{ 'text-decoration': (user.isActive ? 'inherit' : 'line-through') }">
                            <td><router-link :to="{ name: 'user.edit', params: { id: user.UserID } }">{{ user.UserLogin }}</router-link></td>
                            <td><router-link :to="{ name: 'user.edit', params: { id: user.UserID } }">{{ user.FullName }}</router-link></td>
                            <td>{{ user.workTitle }}</td>
                            <td class="text-center">{{ (user.UserTimeCareCode ? 'X' : '' ) }}</td>
                            <td class="text-center">{{ (user.intra_access && user.email ? 'X' : '' ) }}</td>
                            <td class="text-center">{{ (user.allow_remote_login ? (user.has_enabled_two_factor_authentication ? 'X' : '/' ) : '' ) }}</td>
                            <td><a :href="'mailto:' + user.email">{{ user.email }}</a></td>
                            <td><a :href="'tel:' + user.Phone">{{ user.Phone }}</a></td>
                            <td class="text-right" v-if="hasPermission('red_edit_users_timecare')">
                                <template v-if="user.timecares && user.timecares.length > 0">
                                    <i class="icon-warning22 text-danger" :id="'warning-timecares-' + user.UserID"></i>
                                    <b-popover :key="'warning-timecares-' + user.UserID" :target="'warning-timecares-' + user.UserID" triggers="hover focus">
                                        <template #title>Ej godkända tider</template>
                                        <div class="font-weight-semibold" v-for="(time, t_index) in user.timecares" :key="'timecare-user-' + user.UserID + '-' + t_index">{{ time.TimeIN.substring(0, 10) }}</div>
                                    </b-popover>
                                </template>
                                <template v-if="(user.timecares_short && user.timecares_short.length > 0) || (user.long_days && user.long_days.length > 0)">
                                    <i class="icon-database-time2 text-danger" :id="'warning-timecares-short-' + user.UserID"></i>
                                    <b-popover :key="'warning-timecares-short-' + user.UserID" :target="'warning-timecares-short-' + user.UserID" triggers="hover focus">
                                        <div v-if="user.timecares_short && user.timecares_short.length > 0">
                                            <div class="font-weight-bold">Tidrader &lt; 5 min</div>
                                            <div class="font-weight-semibold" v-for="(time, t_index) in user.timecares_short" :key="'timecare-short-user-' + user.UserID + '-' + t_index">{{ time.TimeIN.substring(0, 10) }}</div>
                                        </div>
                                        <div v-if="user.long_days && user.long_days.length > 0">
                                            <div class="font-weight-bold">Dagar &gt; 13 timmar</div>
                                            <div class="font-weight-semibold" v-for="(date, d_index) in user.long_days" :key="'timecare-long-user-' + user.UserID + '-' + d_index">{{ date }}</div>
                                        </div>
                                    </b-popover>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <th :colspan="hasPermission('red_edit_users_timecare') ? 8 : 7">&nbsp;</th>
                        </tr>
                    </tbody>
                </table>
                <div class="card-body" v-else-if="table_data !== null"><i>Inga sökresultat</i></div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import apiClient from '@services/ApiClient';
import { hasPermission } from '@services/Helpers';

export default {
    name: 'UserList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        LimitlessButton,
    },
    data: () => ({
        busy_loading: false,
        table_filter: {
            search: '',
            showhidden: 0,
            // per_page: 999,
            // sort_by_column: 'FullName',
            // sort_by_order: 'asc',
        },
        table_data: null,
        stores: [],
    }),
    mounted() {
        this.getData();
    },
    methods: {
        hasPermission,
        getData() {
            this.busy_loading = true;
            apiClient.get('/vue/users/table', { params: this.table_filter })
                .then((response) => {
                    const stores = [];
                    Object.values(response.data).forEach((value) => {
                        stores.push({ store_id: value.store_id, name: value.name });
                    });
                    this.stores = stores;
                    this.table_data = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        rowClick(data) {
            window.location.href = '/users/' + data.UserID;
        },
    },
};

</script>
